import React from 'react';
import Layout from './components/Layout/Layout';
import KVKK from "./components/sections/Education/Education";

function App() {
  return <Layout />;
}

export default App;
